/**
 * Pushes an object into GTM's data layer.
 * @param {Object} data The payload to send to GTM
 * @returns {void}
 */
export default function pushToDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  Array.isArray(data)
    ? window.dataLayer.push(...data)
    : window.dataLayer.push(data);
}



// WEBPACK FOOTER //
// ./src/utils/gtm/api/pushToDataLayer.js